<template>
  <div :class="['bg-gray-200', 'relative', 'overflow-hidden']">
    <SvgDots :class="['absolute left-1/2 -translate-x-1/2 z-0 scale-110', 'h-full']" />
    <!-- 多行轮播图容器 -->
    <div :class="['flex flex-col', 'lg:py-40 py-20']">
      <CommonBanner
        :title="t('page.index.partner.fragment.title')"
        :desc="t('page.index.partner.fragment.desc')"
        class="lg:mb-20 mb-10"
        theme="light"
      />
      <!-- 轮播图组容器 -->
      <div :class="['flex flex-col lg:gap-y-4 gap-y-2']">
        <!-- 多行轮播图，通过ps-控制间距，反向播放属性:auto-scroll="{ direction: 'backward' }" -->
        <Motion
          v-for="(_, index) in TOTAL_CAROUSEL"
          :key="`partner-${index}`"
          :initial="{ opacity: 0, y: 120 }"
          :while-in-view="{ opacity: 1, y: 0 }"
          :transition="{
            type: 'spring',
            stiffness: 20,
            damping: 10,
            delay: index * 0.1,
          }"
          :in-view-options="{
            once: true,
          }"
        >
          <UCarousel
            v-slot="{ item }"
            :items="getOffsetPartners(index)"
            loop
            :align="index % 2 === 0 ? 'start' : 'end'"
            :auto-scroll="{
              speed: 1,
              direction: index % 2 === 0 ? 'forward' : 'backward',
              stopOnInteraction: false,
            }"
            :ui="{
              root: 'w-full lg:mask-x-from-80% mask-x-from-95% mask-x-to-100%',
              viewport: '',
              item: 'md:basis-60 basis-40 lg:mx-2 mx-1',
            }"
          >
            <!-- 单个Logo背景容器 -->
            <div
              :class="[
                'flex items-center justify-center',
                'lg:h-32 h-24',
                'bg-default rounded-lg transform hover:cursor-grab',
                'active:scale-95 transition-all',
              ]"
            >
              <!-- 未撑满容器宽度的Logo图片 -->
              <NuxtImg
                :src="`/img/partner/${item}.png`"
                class="lg:w-32 w-24 select-none"
                :alt="`Partner Logo - ${item}`"
                draggable="false"
                loading="lazy"
              />
            </div>
          </UCarousel>
        </Motion>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  /** 轮播图总列数 */
  const TOTAL_CAROUSEL = 4

  /** 合作伙伴文件名前缀 (真实格式需统一为png) */
  const partners = [
    'damco',
    'agility',
    'mainfreight',
    'nippon-express',
    'ceva',
    'samsung',
    'spread-logistics',
    'apl-logistics',
    'oocl',
    'ocean-world-lines',
    'atlantic-forwarding',
    'jas',
    'hansol-chemical',
    'gateway-logistics',
    'foxconn',
    'htns',
    'hehuang',
    'unitex',
    'toll',
    'mitsubishi',
    'lf-logistics',
    'hnfriends',
  ]

  /** 生成不同偏移量的数据源 */
  const getOffsetPartners = (index: number) => {
    const chunkSize = Math.ceil(partners.length / TOTAL_CAROUSEL)
    const start = index * chunkSize
    const end = start + chunkSize
    const chunk = partners.slice(start, end)
    // 将chunk重复多次，以形成足够长的轮播数据
    return [...chunk, ...chunk, ...chunk] // 重复多次以避免同一行内快速重复
  }
</script>
